import { camelWorkspacePath, camelWorkspaceScope } from '../apiScope';
import type { PatientEventsFilters } from './types';

export const patientEventsBaseQueryKey = (workspaceUuid: string, patientUuid: string) =>
  [...camelWorkspaceScope(workspaceUuid), 'patients', patientUuid, 'events'] as const;

export const patientEventsFeedQueryKey = (
  workspaceUuid: string,
  patientUuid: string,
  filters: PatientEventsFilters,
) => [...patientEventsBaseQueryKey(workspaceUuid, patientUuid), { filters }] as const;

export const patientEventsFamiliesQueryKey = (workspaceUuid: string, patientUuid: string) =>
  [...patientEventsBaseQueryKey(workspaceUuid, patientUuid), 'families'] as const;

export const patientEventsPointsQueryKey = (
  workspaceUuid: string,
  patientUuid: string,
  filters: PatientEventsFilters,
) => [...patientEventsBaseQueryKey(workspaceUuid, patientUuid), 'points', { filters }] as const;

export const patientEventsPresetsQueryKey = (workspaceUuid: string) =>
  [...camelWorkspaceScope(workspaceUuid), 'patient-events', 'presets'] as const;

export const patientEventsBasePath = (workspaceUuid: string, patientUuid: string) =>
  camelWorkspacePath(workspaceUuid, 'patients', patientUuid, 'events');

export const DEFAULT_EVENTS_PAGE_LIMIT = 25;
